import memoizeOne from 'memoize-one';
import type { JsonLd } from 'json-ld-types';

import { EditorCardProvider } from '@atlaskit/editor-card-provider';

import { expVal } from '@confluence/feature-experiments';
import { InlineCommentEditorCardProvider } from '@confluence/comments-util/entry-points/classes.ts';

export const getSmartCardOptions = memoizeOne((enableChromelessEditorCardProvider: boolean) => {
	/**
	 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
	 * (only supports Cloud single-issue URLs right now)
	 */
	const smartLinksBeforeMacros =
		'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(
			',',
		);

	const cardProvider = enableChromelessEditorCardProvider
		? new InlineCommentEditorCardProvider(undefined, undefined, 'CONFLUENCE')
		: new EditorCardProvider(undefined, undefined, 'CONFLUENCE');

	if (expVal('platform_editor_smart_card_otp', 'isEnabled', false)) {
		if (!enableChromelessEditorCardProvider) {
			const ssrProvidersData: { editorCardProvider?: Record<string, JsonLd.Response> } =
				window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
			const ssrData = ssrProvidersData[cardProvider.name];

			cardProvider.setSSRData(ssrData);
		}
	}

	// IMPORTANT: If you change the code below, please also update the
	// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/pastePluginOptions.ts
	// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/cardPluginOptions.ts
	return {
		provider: Promise.resolve(cardProvider),
		resolveBeforeMacros: smartLinksBeforeMacros,
		allowBlockCards: true,
		allowEmbeds: true,
	};
});
